const React = require('react');
const Dialog = require('./dialog.jsx');

require('./message-dialog.scss');

module.exports = React.createClass({
  displayName: 'MessageDialog',
  propTypes: {
    btnText: React.PropTypes.any,
    children: React.PropTypes.any,
    onCancel: React.PropTypes.func,
    onConfirm: React.PropTypes.func,
  },
  getDefaultProps() {
    return {};
  },
  onConfirm(evt) {
    if (evt) {
      evt.preventDefault();
    }

    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  },
  onCancel(evt) {
    if (evt) {
      evt.preventDefault();
    }
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  },
  render() {
    const { btnText } = this.props;
    const buttons = [
      {
        text: btnText,
        className: 'dialog-btn',
        onClick: this.onConfirm,
      },
    ];

    return (
      <Dialog
        theme="sliver"
        onClose={this.onCancel}
        buttons={buttons}
        className="message-dialog"
      >
        {this.props.children}
      </Dialog>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/mui/dialog/message-dialog.jsx